export default "__VITE_ASSET__CDb_PPfz__"